import {db, storage} from '@/firebase';
import {randomString} from '@/utils/utils.js'
export default {
    getTotems({commit,rootState}){
        let negocio = rootState.app.negocioGest;
        let devolver = [];
        return db.collection('negocios').doc(negocio).collection('totems').get()
        .then((res) => {
            res.forEach(doc => {
                let aux = doc.data();
                aux.id = doc.id;
                devolver.push(aux);
            });
            return devolver;
        })
        .then((res) => {
            var actions = res.map(function (item){
                var storageRef1 = storage.ref('imagenes/totems/' + item.id + '_fondo.jpg');
                var p1 = storageRef1.getDownloadURL()
                .then((r) => {
                    item.imagenFondo = r;
                })
                .catch((e) => {
                    item.imagenFondo = false;
                })
                var storageRef2 = storage.ref('imagenes/totems/' + item.id + '_logo.jpg');
                var p2 = storageRef2.getDownloadURL()
                .then((r) => {
                    item.imagenLogo = r;
                })
                .catch((e) => {
                    item.imagenLogo = false;
                })
                return Promise.all([p1,p2])
                .then(()=> {
                    return item;
                })
            });
            return Promise.all(actions)
            .then((r) => {
                commit('setTotemsArray',r)
            })
            .catch((e) => {
                console.log(e);
            })
        })  
    },
    addTotem({rootGetters,rootState},t){
        let negocioObj = rootGetters['app/negocioGestObj']
        let negocio = rootState.app.negocioGest;
        let imagenFondo = t.imagenFondo;
        let imagenLogo = t.imagenLogo;
        console.log(negocioObj);
        let id = t.id;
        if (!id)
            id = negocioObj.cod + '-' + randomString(10);
            delete t.negocio;
            delete t.imagenFondo;
            delete t.imagenLogo;
            delete t.id;
        return db.collection('negocios').doc(negocio).collection('totems').doc(id).set(t,{merge:true})
        .then(() => {
            let arrayPromesas = [];
            if (imagenFondo){
                var storageRef = storage.ref();
                var ref = storageRef.child('imagenes/totems/' + id + '_fondo.jpg');
                arrayPromesas.push(ref.put(imagenFondo));
            }  
            if (imagenLogo){
                var storageRef = storage.ref();
                var ref = storageRef.child('imagenes/totems/' + id + '_logo.jpg');
                arrayPromesas.push(ref.put(imagenLogo));
            }  
            return Promise.all(arrayPromesas);         
        })
    },
    deleteTotem({commit,rootState},item){
        let negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio).collection('totems').doc(item.id).delete()
    },
    changeActivoTotem({rootState},item){
        let negocio = rootState.app.negocioGest;
        let value = {};
        value.activo = item.activo;
        return db.collection('negocios').doc(negocio).collection('totems').doc(item.id).set(value,{merge:true})
    },
    addImpresoraTotem({rootState},{item,impresora}){
        console.log(item);
        console.log(impresora);
        let negocio = rootState.app.negocioGest;
        let value = {};
        value.impresora = impresora;
        return db.collection('negocios').doc(negocio).collection('totems').doc(item.id).set(value,{merge:true})
    }
}